import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { applyHooks } from '../classes/modelLoadHooks';

declare var THREE: any;

type Ok = (obj) => void;

interface IPendingModels {
  [name: string]: Ok[];
}

@Injectable()
export class ModelLoaderService {
  apiUrl: string = environment.apiUrl;

  private cache: Array<any> = [];
  private lightedCache: Array<any> = [];
  private cache135degree: any[] = [];
  private cache45degree: any[] = [];

  private localModels: any = {};
  private localModelsPending: IPendingModels = {};
  // possible refactor to reuse loaders
  private objLoader: any = new THREE.OBJLoader();
  private mtlLoader: any = new THREE.MTLLoader();

  loadModel(entity, specialModel?: string): Promise<any> {
    const promise = new Promise((resolve, reject) => {
      let mtlName: string, objName: string;

      switch (specialModel) {
        case 'lighting':
          {
            mtlName = entity.modelLightingMtl;
            objName = entity.modelLightingObj;
            for (let i = 0; i < this.lightedCache.length; i++) {
              const model = this.lightedCache[i];
              if (model.userData.entity && model.userData.entity.id === entity.id) {
                const modelClone = model.clone();
                resolve(modelClone);
                return;
              }
            }
          }
          break;
        case '45degree':
          {
            mtlName = entity.model45Mtl;
            objName = entity.model45Obj;
            for (let i = 0; i < this.cache45degree.length; i++) {
              const model = this.cache45degree[i];
              if (model.userData.entity && model.userData.entity.id === entity.id) {
                const modelClone = model.clone();
                resolve(modelClone);
                return;
              }
            }
          }
          break;
        case '135degree':
          {
            mtlName = entity.model135Mtl;
            objName = entity.model135Obj;
            for (let i = 0; i < this.cache135degree.length; i++) {
              const model = this.cache135degree[i];
              if (model.userData.entity && model.userData.entity.id === entity.id) {
                const modelClone = model.clone();
                resolve(modelClone);
                return;
              }
            }
          }
          break;
        default:
          {
            mtlName = entity.modelMtl;
            objName = entity.modelObj;
            for (let i = 0; i < this.cache.length; i++) {
              const model = this.cache[i];
              if (model.userData.entity && model.userData.entity.id === entity.id) {
                const modelClone = model.clone();
                resolve(modelClone);
                return;
              }
            }
          }
          break;
      }

      // if (lighted) {
      //   for (let i = 0; i < this.lightedCache.length; i++) {
      //     const model = this.lightedCache[i];
      //     if (model.userData.entity && model.userData.entity.id === entity.id) {
      //       let modelClone = model.clone();
      //       resolve(modelClone);
      //       return;
      //     }
      //   }
      // }
      // else {
      //   for (let i = 0; i < this.cache.length; i++) {
      //     const model = this.cache[i];
      //     if (model.userData.entity && model.userData.entity.id === entity.id) {
      //       let modelClone = model.clone();
      //       resolve(modelClone);
      //       return;
      //     }
      //   }
      // }

      // let mtlName = lighted ? entity.modelLightingMtl : entity.modelMtl,
      //   objName = lighted ? entity.modelLightingObj : entity.modelObj;

      // localAsset entities (temporary client-side products) ship their
      // OBJ/MTL under assets/models instead of the API model store
      const baseUrl = entity.localAsset
        ? '../../assets/models/'
        : `${this.apiUrl}/containers/models/download/`;

      const localMtlLoader = new THREE.MTLLoader();
      if (entity.localAsset) {
        // resolve map_Kd & co next to the .mtl file (r94 default is page root)
        localMtlLoader.setTexturePath(
          baseUrl + mtlName.substring(0, mtlName.lastIndexOf('/') + 1)
        );
      }

      localMtlLoader.load(
        `${baseUrl}${mtlName}`,
        materials => {
          materials.preload();

          new THREE.OBJLoader().setMaterials(materials).load(
            `${baseUrl}${objName}`,
            mesh => {
              mesh.userData.entity = entity;

              switch (specialModel) {
                case 'lighting':
                  {
                    this.lightedCache.push(mesh);
                  }
                  break;
                case '45degree':
                  {
                    this.cache45degree.push(mesh);
                  }
                  break;
                case '135degree':
                  {
                    this.cache135degree.push(mesh);
                  }
                  break;
                default:
                  {
                    this.cache.push(mesh);
                  }
                  break;
              }

              // if (lighted)
              //   this.lightedCache.push(mesh);
              // else
              //   this.cache.push(mesh);

              resolve(mesh);
            },
            xhr => {
              // console.log((xhr.loaded / xhr.total * 100) + '% model cable loaded');
            },
            error => {
              // console.log('An error happened');
              console.log(error);
            }
          );
        }
      );
    });
    return promise;
  }

  loadLocalModel(fileName): Promise<any> {
    this.localModelsPending[fileName] = this.localModelsPending[fileName] || [];

    const pending = this.localModelsPending[fileName];
    const localModel = this.localModels[fileName];

    if (localModel) {
      const model = localModel.clone();
      applyHooks(model);
      return Promise.resolve(model);
    }

    if (pending.length === 0) {
      this.mtlLoader.load(`../../assets/models/${fileName}.mtl`, materials => {
        materials.preload();
        this.objLoader.setMaterials(materials).load(
          `../../assets/models/${fileName}.obj`,
          obj => {
            this.localModels[fileName] = obj;
            pending.forEach(ok => {
              const model = obj.clone();
              applyHooks(model);
              ok(model);
            });
            delete this.localModelsPending[fileName];
          },
          undefined,
          error => {
            console.error('Error load local model', error);
          }
        );
      });
    }

    return new Promise(ok => {
      pending.push(ok);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/model-loader.service.ts